
export function inputUsernameAction(username:string){
    return {
        type: '@@UserAuth/inputUsernameAction' as const ,
        username
    }
}

export function inputPasswordAction(password:string){
    return {
        type: '@@UserAuth/inputPasswordAction' as const ,
        password
    }
}


export function changeisAuthenticatedAction(isAuthenticated:boolean){
    return {
        type: '@@UserAuth/changeisAuthenticatedAction' as const ,
        isAuthenticated
    }
}

export function loginFail() {
    return {
      type: "@@UserAuth/LOGIN_FAIL" as const,
    };
}

export function loginSuccess(token: string) {
    return {
      type: "@@UserAuth/LOGIN_SUCCESS" as const,
      token
    };
}





export type UserAuthAction =
|ReturnType<typeof inputUsernameAction>
|ReturnType<typeof inputPasswordAction>
|ReturnType<typeof changeisAuthenticatedAction>
| ReturnType<typeof loginFail>
| ReturnType<typeof loginSuccess>
